import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { DeviceViews } from 'models';

@Injectable({
  providedIn: 'root'
})
export class DeviceViewService {

  constructor(
    @Inject(DOCUMENT) private document: Document 
  ) { }

  getDeviceView(): DeviceViews {
    let view: DeviceViews = 'desktop';
    const MOBILEVIEWWIDTH = 766;
    const containerEl = document.getElementById('comparatoreMFPanels');

    view = containerEl && containerEl.offsetWidth <= MOBILEVIEWWIDTH ? 'mobile' : 'desktop';

    return view
  }
}
